(function($) {

  
  	$('div.accordion h3').on('click', function() {
      
        if ( $(this).parent().hasClass( "active" ) ) {
 			
          	var id = $(this).attr("data-acc");
			$(this).find('i').toggleClass("fa-minus");
          	$(id).slideUp();
          	$(this).parent().removeClass('active');
        }
      
      else{
        	var id = $(this).attr("data-acc");
            

            $( ".accordion-holder div" ).each(function( index ) {
                $(this).removeClass('active').removeClass("open");
            });

            $( ".accordion-holder div.single-content" ).each(function( index ) {
                $(this).slideUp();
            });
        
        	$( ".accordion-holder i" ).each(function( index ) {
                $(this).removeClass('fa-minus');
            });
       		
        	$(this).parent().addClass("active");
        
        	$(this).find('i').toggleClass("fa-minus");
        
        	$(id).slideDown();
        
        
        }   	
      	
	});
  
  
    $(window).scroll(function(){
      
      if(document.body.clientWidth >= 640){
      	if ($(window).scrollTop() > 1) {
          	$('.page-header__main').addClass('fixed-header');
          	var height = $('.page-header__main').height();
            $('.page-main').css("padding-top", height);
            	
          }
          else if ($(window).scrollTop() <= 1) {
              $('.page-header__main').removeClass('fixed-header');
            	$('.page-main').css("padding-top", "0");
          }
      }
          
    });
  
  
  $.urlParam = function(name){
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results==null) {
         return null;
      }
      return decodeURI(results[1]) || 0;
  }
  
  
//   if($.urlParam('ref') == "popup"){
  	
//     var inTwelveHours = new Date(new Date().getTime() + (365 * 24 * 3600 * 1000));
// 		Cookies.set('country-shown', true, {
// 		    expires: inTwelveHours
// 	 });
  
//   }
  
//   else if (!Cookies.get('country-shown')) {

//       $.get("https://ipinfo.io", function(response) {

//           if(response.country =="CA"){
//                 jQuery.magnificPopup.open({
//                 items: [
//                   {
//                     src: '#popup-canada', // CSS selector of an element on page that should be used as a popup
//                     type: 'inline'
//                   }
//                 ],
//                 removalDelay: 300,
//                 mainClass: 'mfp-fade',
//                 closeOnContentClick: true,
//                 closeBtnInside: true
//               });

//           }

//           else if(response.country =="US"){
//                 jQuery.magnificPopup.open({
//                 items: [
//                   {
//                     src: '#popup-usa', // CSS selector of an element on page that should be used as a popup
//                     type: 'inline'
//                   }
//                 ],
//                 removalDelay: 300,
//                 mainClass: 'mfp-fade',
//                 closeOnContentClick: true,
//                 closeBtnInside: true
//               });

//           }



//       }, "jsonp");
    
//      var inTwelveHours = new Date(new Date().getTime() + (365 * 24 * 3600 * 1000));
// 		Cookies.set('country-shown', true, {
// 		    expires: inTwelveHours
// 	 });
//   }
  
//   $.get("https://ipinfo.io", function(response) {

//           if(response.country =="CA"){
            
// 			$('#country_0').val("ca"); 
//             alert("Canada");
//           }

//           else if(response.country =="US"){
// 			$('#country_0').val("us"); 
//             alert("US");
//           }

//   }, "jsonp");
  
  
  
  $.get("https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&access_token=IGQVJXUC1uNGdIRFAzd2lWT2EwajdwOUFsdmYwRVFZARW15LTdPMC1GeDljWWRSbFZAEeHJJYmZATYlRJalMwUm4tajhfQkljWEdlVFlITWhPVTRXd0piakNNX3Bvb25OMlRoUjVFcjZArRzZAoNjRUYkxKegZDZD", function(response){
  	//console.log(response);
  }, "jsonp");
  
  
  
})(jQuery);